export enum MoveStatus {
    All = 'all',
    Convert = 'convert',
    Book = 'book',
    Transfer = 'transfer',
    TransferLeaver = 'transferLeaver',
    Interview = 'interview',
}
